import { render, staticRenderFns } from "./UnpaidShifts.vue?vue&type=template&id=c051faee"
import script from "./UnpaidShifts.vue?vue&type=script&lang=js"
export * from "./UnpaidShifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports